import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageLineReport from '../../components/PageLineReport';

const AVGKundenScoring = () => {
    return <PageLineReport title="AVG Kunden-Scoring" reportCode={ReportCodes.AvgCustomerScoring} roundDigits />;
};

export default AVGKundenScoring;
